import { ReactNode } from 'react';

export interface KbdProps {
  children: ReactNode;
  className?: string;
}

export function Kbd({ children, className = '' }: KbdProps) {
  return <span className={`ds-kbd ${className}`.trim()}>{children}</span>;
}

export default Kbd;
